import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8326t3xrxv: FaireBrandEntity = {
  token: "b_8326t3xrxv",
  type: "brand",
  name: "Flower Child Fudge",
  avatarUrl:
    "https://cdn.faire.com/fastly/f5f89951ece3431e8ec383aa5cafb11310c214412e5c70d9bd062e245ffe99b0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c5d126d373f794230a9000268b80067780d7e6b2487f583499871953932b0446.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f5f89951ece3431e8ec383aa5cafb11310c214412e5c70d9bd062e245ffe99b0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c5d126d373f794230a9000268b80067780d7e6b2487f583499871953932b0446.jpeg",
  location: "Santa Cruz, CA, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi! We’re Flower Child, and we make fudge — but not the kind you’re used to.\n\nOur fudge is sweetened only with dates (yep, the whole fruit!) By doing so, the chocolate doesn’t cause a rapid blood sugar spike. Choosing only superfood ingredients (cacao, coconut, & dates), our fudge crafted to be as kind to the planet as it is to your taste buds. Think rich, chocolatey goodness that still feels indulgent (not too chewy or overly “date-y” like a dried out energy bar.)\n\nEach piece is handmade with love and designed to look as beautiful as it tastes, adorned with a pop of dried flowers on top - a little square of art you can eat. \n\nJust as much love (if not more) goes into our packaging. Since we’re all about sustainability and standing out, each fudge comes in it’s own outfit (an ever-evolving variety of adorable floral fabric pouches). The pouch is then sealed with a ribbon of colored paper according to the flavor (we hand press all our paper and infuse with wildflower seeds) and secured with a bit of melty golden wax, and the fingerprint of the owner, ensuring quite a literal handmade mark. Fudge to savor, fabric to repurpose, and flower to plant. \n\nA truly one of a kind gift to yourself and the Earth!\n\nAnd we’re just getting started. We’ll be adding more specialty treats soon — always made with good-for-you ingredients, and always earth-friendly, right down to the packaging.\n\nTreat yourself (and the planet) to something sweet!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:00.582Z",
    importedBy: "entity-db-cli",
  },
};
